import React, { useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { Input } from "reactstrap";
import { connect } from "react-redux";
import { isIOS } from "react-device-detect";
import { motion } from "framer-motion/dist/framer-motion";

import { fadeVariants, modalSlideVariants } from "shared/components/animations";
import closeIcon from "assets/images/ttl/ttl-close.png";

const AllModal = ({
  roomId,
  ttl_lie,
  playerId,
  mobile_app,
  ttl_truths,
  toggleModal,
  set_ttl_lie,
  modal_title,
  paramsReducer,
  set_ttl_truths
}) => {
  const chooseasker_params = _.get(
    paramsReducer,
    "subGameObj.ttl.app.0_chooseasker"
  );
  const tell_us_text = _.get(chooseasker_params, "tell_us_text", "Tell us:");
  const first_truth_text = _.get(
    chooseasker_params,
    "first_truth_text",
    "First Truth"
  );
  const second_truth_text = _.get(
    chooseasker_params,
    "second_truth_text",
    "Second Truth"
  );

  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const lie_text = _.get(chooseasker_params, "lie_text", "The Lie");
  const save_button = _.get(chooseasker_params, "save_button", "Save & Close");
  const ready_button = _.get(chooseasker_params, "ready_button", "Ready!");

  const onReady = () => {
    toggleModal();
    if (mobile_app) {
      const message = {
        action: "ttl-submit",
        truths: ttl_truths,
        lie: ttl_lie
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "ttl-submit",
        roomId: roomId,
        playerId,
        lie: ttl_lie,
        truths: ttl_truths
      };
      Socket.sendMessage(data);
    }
  };
  const handleInputChange = (e, lie, index) => {
    if (lie) {
      set_ttl_lie(e.target.value);
    } else {
      let array = [...ttl_truths];
      array[index] = e.target.value;
      set_ttl_truths(array);
    }
  };

  const toggle_keyboard = (e) => {
    const action = e.data.action;
    const value = e.data.value;
    if (action === "toggle-keyboard") {
      setKeyboardOpen(value);
    }
  };

  useEffect(() => {
    window.addEventListener("message", toggle_keyboard);
    return () => {
      window.removeEventListener("message", toggle_keyboard);
    };
  }, []);

  return (
    <motion.div
      variants={modalSlideVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`ttl-modal ${!mobile_app && isIOS && "web-ios-cnt"} ${
        mobile_app && isIOS && keyboardOpen && "keyboard-view"
      }`}
    >
      <div onClick={toggleModal} className="ttl-close">
        <img src={closeIcon} alt="" />
      </div>
      <div className="modal-div">
        <motion.h2 variants={fadeVariants} className="ttl-modal-title">
          {modal_title}
        </motion.h2>
      </div>
      <p className="tell-txt">{tell_us_text}</p>
      <div className="mb-3">
        <Input
          type="textarea"
          value={ttl_truths[0]}
          onChange={(e) => handleInputChange(e, false, 0)}
          rows="3"
          cols="10"
          placeholder={first_truth_text}
        />
      </div>
      <div className="mb-3">
        <Input
          type="textarea"
          value={ttl_truths[1]}
          onChange={(e) => handleInputChange(e, false, 1)}
          rows="3"
          cols="10"
          placeholder={second_truth_text}
        />
      </div>
      <div className="mb-3">
        <Input
          type="textarea"
          value={ttl_lie}
          onChange={(e) => handleInputChange(e, true)}
          rows="3"
          cols="10"
          placeholder={lie_text}
        />
      </div>
      <div className="modal-button">
        <button onClick={toggleModal} className="save-btn">
          {save_button}
        </button>
        <button onClick={onReady} className="ready-btn">
          {ready_button}
        </button>
      </div>
    </motion.div>
  );
};
const mapStateToProps = (state) => ({
  sbsReducer: state.sbsReducer,
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
export default connect(mapStateToProps, null)(AllModal);
